import { render, staticRenderFns } from "./EmpresaHistoricoRecebimentos.vue?vue&type=template&id=8951964a&lang=pug"
import script from "./EmpresaHistoricoRecebimentos.vue?vue&type=script&lang=js"
export * from "./EmpresaHistoricoRecebimentos.vue?vue&type=script&lang=js"
import style0 from "./EmpresaHistoricoRecebimentos.vue?vue&type=style&index=0&id=8951964a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports